<cerrix-loader [cerrixTab]="tab" [showLoader]="!finishedLoading"></cerrix-loader>

@if (finishedLoading && detailsModel) {
    <div>
        @if (!hideActionBar) {
            <div class="detail-page-action-bar flex-action-bar">
                <div>
                    <button class="btn btn-cerrix" [disabled]="!saveAllowed" (click)="save()">
                        <i class="fas fa-save"></i>
                        <span data-uiid="fr-assessment-save" class="d-none d-lg-inline">{{ 'saveBtn' | t }}</span>
                    </button>

                    @if (detailsModel.modifiedAt) {
                        <span class="date-edited">
                            {{ 'lastSave' | t: { modifiedAt: (detailsModel.modifiedAt | dateTimeFormat) } }}
                        </span>
                    }
                </div>
            </div>
        }

        <div menuSystem [cerrixTab]="tab" class="assessment" (changeEvent)="onMenuItemClick($event)">
            <div menuItemId="menuItemAssessment" [attr.name]="'menuAssessment' | t" menuicon="fas fa-poll-people" menusystemsubmenu>
                <div
                    menuItemId="details"
                    [attr.name]="'menuDetails' | t"
                    menusystemitem
                    menuicon="fas fa-info-circle"
                >
                    <assessment-details-main
                        [formGroup]="formGroup"
                        [detailsModel]="detailsModel"
                        [editAllowed]="saveAllowed"
                    >
                    </assessment-details-main>
                </div>
                @if (detailsModel.guid) {
                    <div menuItemId="menuItemLinks" [attr.name]="'menuLinks' | t" menusystemsubmenu menuicon="fas fa-link">
                        <div
                            menuItemId="mois"
                            [attr.name]="'menuMeasureOfImprovements' | t"
                            menusystemitem
                            menuicon="fas fa-tasks"
                        >
                            <linked-moi-overview
                                [moiType]="moiType"
                                [parentGuid]="detailsModel.findingReportGuid"
                                [assessmentGuid]="detailsModel.guid"
                                [canAdd]="permissionsModel.canAddMoi"
                                [canDelete]="permissionsModel.canDeleteMoi"
                                [useLazyLoading]="false"
                            >
                            </linked-moi-overview>
                        </div>
                    </div>
                    <div
                        menuItemId="history"
                        [attr.name]="'menuHistory' | t"
                        menusystemitem
                        menuicon="fas fa-history"
                    >
                        <app-history-overview
                            [historyDataService]="assessmentService"
                            [Id]="detailsModel.guid"
                            #historyOverviewComponent
                        >
                        </app-history-overview>
                    </div>
                }
            </div>
        </div>
    </div>
}
